import { MealType } from '../../types/dailyMenu';

export const MEAL_TYPE_OPTIONS: { label: string; value: MealType }[] = [
  { label: 'Desayuno', value: 'Breakfast' },
  { label: 'Comida', value: 'Lunch' },
  { label: 'Cena', value: 'Dinner' },
];

export const MEAL_TYPE_LABELS: Record<MealType, string> = {
  Breakfast: 'Desayuno',
  Lunch: 'Comida',
  Dinner: 'Cena',
};

export const MEAL_TYPE_COLORS: Record<MealType, string> = {
  Breakfast: 'orange',
  Lunch: 'blue',
  Dinner: 'purple',
};
